import { BasisType, Goal, Service, ICompanyLeadSettings, CompanyLead, Address, ProductsCompany } from "@raskrask-dk/raskrask-utils";
import {Next, SetGoal, SetServiceType, SetCompanySettings} from "./actions";

export type CompanyActions = Next | SetGoal | SetServiceType | SetCompanySettings;

export const companyActions = [Next, SetGoal, SetServiceType, SetCompanySettings] as const;

export type compActions = typeof companyActions[number];

export interface IGetData {
  basisType: BasisType;
  goal?: Goal;
  serviceType?: Service;
  companySettings?: ICompanyLeadSettings;
  product: CompanyLead;
}

export interface CompanyLeadDependencies {
  address: Address;
  basisType: BasisType;
  productType: ProductsCompany;
}
